module.exports = __webpack_public_path__ + "static/media/MasterBed2-2.9d671552.jpg";